export const images=[
    {src:require("./gqyz.png"),tag:null,url:null},
    {src:require("./xjxq.jpg"),tag:'其他作品',url:null},
    {src:require("./rgq.jpg"),tag:null,url:null},
    //{src:require("./xcgq.webp"),tag:null},
    {src:require("./mssrf.jpg"),tag:'其他作品',url:"https://morse.lhcyh.site"}
]